import type { ApiResponse } from '@shared/types'
import { BackendServiceName } from 'v2/types'
import { createService } from './create-service'

export interface CustomField {
  create: boolean
  edit: boolean
  field_identifier: string
  field_metadata: unknown
  title: string
  view: boolean
}

export interface BatchCustomFieldsResponse {
  fields_by_entity: Record<string, CustomField[]>
}

export interface SecretVariable {
  id: string
  name: string
  display_name?: string
  value: string
  description: string
  created_at: string
  updated_at: string
  created_by: {
    uuid: string
    name: string
  }
}

export interface AppVariables {
  [key: string]: SecretVariable[]
}

const EXTERNAL_ENDPOINTS = {
  appVariables: 'app-variables',
}

interface ExternalService {
  getAppVariables: () => Promise<ApiResponse<AppVariables>>
}

const serviceFactory = (): ExternalService => {
  const service = createService('', true, BackendServiceName.externalApps, 'v1')
  return {
    getAppVariables: () => service.get(EXTERNAL_ENDPOINTS.appVariables),
  }
}

export const externalService = serviceFactory()
